// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"nameCell__YuA+c","content":"content__tnKnm","name":"name__5XAbN"};